// التقرير الشهري للسيارات (pages/car-monthly-report.tsx) — المالك 2026-10-26.
const EN_B16: Record<string, string> = {
  "التقرير الشهري للسيارات": "Monthly vehicle report",
  "دخل كل سيارة في الشهر من سندات القبض، وعدد عقودها": "Each vehicle's income for the month from receipts, and its contracts",
  "كل الفروع": "All branches",
  "فور رنت": "4Rent",
  "كابري": "Capri",
  "بحث برقم اللوحة أو السيارة...": "Search by plate or vehicle...",
  "إجمالي الدخل (د.ك)": "Total income (KWD)",
  "سيارات عليها دخل": "Vehicles with income",
  "عقود جديدة": "New contracts",
  "عقود محصّلة": "Collected contracts",
  "سندات القبض": "Receipts",
  "الدخل (د.ك)": "Income (KWD)",
  "لوحة": "Plate",
  "لا توجد حركة في هذا الشهر": "No activity this month",
  "تعذّر التصدير": "Export failed",
  "الدخل = سندات القبض المؤرخة داخل الشهر على عقود السيارة (Drive8). عقود جديدة = بدأت في الشهر، وعقود محصّلة = قُبض عنها في الشهر ولو بدأت قبله. الليموزين والسندات بلا عقد غير داخلة.":
    "Income = receipts dated within the month on the vehicle's contracts (Drive8). New contracts = started this month; collected contracts = paid this month even if started earlier. Limousine and receipts without a contract are excluded.",
};
export default EN_B16;
